/** Import modules */

import { useTranslation }       from "react-i18next";

import { SEO_ORIGIN }           from "../../Components/SEO/localizedMeta";

/** Import components */

import BlogLayout               from "../../Components/Blog/Layout";

import BlogCollection           from "../../Components/Blog/Collection";

import Breadcrumbs              from "../../Components/Layout/Header/Breadcrumbs";

import { Helmet }               from "react-helmet-async";

/**
 * 
 * @returns Blog page
 * 
 */

const Blog = () => { const { t } = useTranslation ();

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "blog" ) }` }</title>

            <link rel="canonical" href={`${ SEO_ORIGIN }/blog`} />

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "blog" ), URI: "/blog" }

        ] } />

        <BlogLayout title={ t ( "blog" ) }>

            <BlogCollection />

        </BlogLayout>
        
    </div> );

}

/** Export component */
 
export default Blog;